import { create } from 'zustand'
import { DEFAULT_FEATURE_FLAGS, type FeatureFlags } from '@/types/featureFlags'

interface FeatureFlagState {
  flags: FeatureFlags
  /**
   * False until the first fetch resolves (success or failure). Gates that
   * depend on a flag being OFF (e.g. the email-verification bounce) should
   * wait for this so users aren't redirected on the cautious defaults while
   * the real flags are still in flight.
   */
  loaded: boolean

  setFlags: (flags: FeatureFlags) => void
}

export const useFeatureFlagStore = create<FeatureFlagState>((set) => ({
  flags: DEFAULT_FEATURE_FLAGS,
  loaded: false,

  setFlags: (flags) => set({ flags, loaded: true }),
}))
